export default __webpack_public_path__ + "static/media/guide_041.94024843.md";